export const USER_PROF_REGIST = 'USER_PROF_REGIST';
export const USER_PROF_REGIST_REQUEST = 'USER_PROF_REGIST_REQUEST';
export const USER_PROF_REGIST_RESULT = 'USER_PROF_REGIST_RESULT';
export const USER_PROF_REGIST_RESET = 'USER_PROF_REGIST_RESET'


// WEBPACK FOOTER //
// ./src/constants/User/FirstProfRegist.js